import { useState, useCallback } from 'react'
import { createFileRoute } from '@tanstack/react-router'
import { FullPage } from '@/components/common/FullPage'
import { EntryForm } from '@/components/features/entries/EntryForm'

interface NewEntrySearch {
  /** When true (from the dashboard "Voice entry" tile), auto-start voice capture. */
  voice?: boolean
}

export const Route = createFileRoute('/_authenticated/entries_/new')({
  validateSearch: (search: Record<string, unknown>): NewEntrySearch => ({
    voice: search.voice === true || search.voice === 'true' || search.voice === 1,
  }),
  component: NewEntryPage,
})

function NewEntryPage() {
  const { voice } = Route.useSearch()
  const [footerEl, setFooterEl] = useState<HTMLDivElement | null>(null)
  const footerRef = useCallback((node: HTMLDivElement | null) => setFooterEl(node), [])
  const [actionsEl, setActionsEl] = useState<HTMLDivElement | null>(null)
  const actionsRef = useCallback((node: HTMLDivElement | null) => setActionsEl(node), [])

  return (
    <FullPage
      title="New Activity"
      actions={<div ref={actionsRef} />}
      footer={<div ref={footerRef} />}
    >
      {(close) => (
        <EntryForm
          onSuccess={close}
          onCancel={close}
          actionBarContainer={footerEl}
          headerActionsContainer={actionsEl}
          autoStartVoice={voice}
        />
      )}
    </FullPage>
  )
}
